export const FETCH_ACCOUNT_TAGS = 'FETCH_ACCOUNT_TAGS';
export const SET_ACCOUNT_TAGS_FETCHING = 'SET_ACCOUNT_TAGS_FETCHING';
export const REPLACE_ACCOUNT_TAGS = 'REPLACE_ACCOUNT_TAGS';
export const SET_ACCOUNT_TAGS_ERRORED = 'SET_ACCOUNT_TAGS_ERRORED';
export const CREATE_TAG = 'CREATE_TAG';
export const UPDATE_STEP_TAGS = 'UPDATE_STEP_TAGS';
export const DELETE_TAG = 'DELETE_TAG';
export const EDIT_TAG = 'EDIT_TAG';
export const UPDATE_TAGS_MANAGEMENT_STATE = 'UPDATE_TAGS_MANAGEMENT_STATE';
